export const MlCoreFamily = {
    GPU: 'GPU',
    Standard: 'Standard',
};
